import goaImg from "../assets/images/webp/other/dvm-goa-img.webp";
import sanjeevniHotelImg from "../assets/images/webp/other/sanjeevni-hotel-img.webp";
import mindKingImg from "../assets/images/webp/other/mind-king-book.webp";
import mobileImg from "../assets/images/webp/other/mobile-img.webp";
import audioBookImg from "../assets/images/webp/other/audio-book-img.webp";
import user1 from "../assets/images/webp/user-one.webp";
import user2 from "../assets/images/webp/user-two.webp";
import user3 from "../assets/images/webp/user-three.webp";

import spotlightImgOne from "../assets/images/webp/spotlight-img-one.webp";
import spotlightImgTwo from "../assets/images/webp/spotlight-img-two.webp";
import spotlightImgThree from "../assets/images/webp/spotlight-img-three.webp";
import spotlightImgFour from "../assets/images/webp/spotlight-img-four.webp";
import spotlightImgFive from "../assets/images/webp/spotlight-img-five.webp";
import youtubeImg from "../assets/images/webp/youtube-img.webp";
import poadcastImg from "../assets/images/webp/live-poadcast.webp";
import selfRelienceImg from "../assets/images/webp/self-reliance-img.webp";
import achieveSuccessImg from "../assets/images/webp/achieve-success-img.webp";
import educationRoleImg from "../assets/images/webp/education-role-img.webp";
import ordinaryImg from "../assets/images/webp/ordinary-img.webp";
import newsPaperOne from "../assets/images/webp/news-paper-one.webp";
import newsPaperTwo from "../assets/images/webp/news-paper-two.webp";
import newsPaperThree from "../assets/images/webp/news-paper-three.webp";
import freeCoachingImg from "../assets/images/png/free-coaching-img.png";
import oneTreeImg from "../assets/images/png/one-tree-img.png";
import womenEmpowerImg from "../assets/images/png/women-empoerment-img.png";
import bloodImg from "../assets/images/png/blood-donation-img.png";
import visonImg from "../assets/images/png/vision-youth-img.png";
import magnaticImg from "../assets/images/webp/mangnetic-devices.webp";
import waterRescorseImg from "../assets/images/webp/water-devices-img.webp";
import accessImg from "../assets/images/png/access-advance-img.png";
import worldImg from "../assets/images/png/world-wide-icon.png";
import sustainImg from "../assets/images/png/sustainable-img.png";
export const HEADER_LIST = [
  {
    title: "Home",
    path: "/home",
  },
  {
    title: "About Us",
    path: "/about-us",
    submenu: [
      {
        title: "Make Way India Infra Pvt. Ltd.",
        path: "/make-way-india-infra-pvt-ltd.",
      },
      {
        title: "Make Way India Corporation",
        path: "/make-way-india-corporation",
      },
      {
        title: "Make Way India Consultancy",
        path: "/make-way-india-consultancy",
      },
      {
        title: "Make Way India Invention Pvt. Ltd.",
        path: "/make-way-india-invention-pvt-ltd.",
      },
    ],
  },
  {
    title: "Misson",
    path: "/misson",
  },
  {
    title: "Vision",
    path: "/vision",
  },
  {
    title: "Gallery ",
    path: "/gallery ",
  },
  {
    title: "Blog",
    path: "/blog",
  },
  {
    title: "Contact Us",
    path: "/contact-us",
  },
];

export const ABOUT_BOOK_LIST = [
  "Reprogram Your Mind",
  "Set Higher Standards",
  "Break Mental Barriers",
  "Unlock True Potential",
];

export const FORMAT_LIST = [
  {
    img: mindKingImg,
    title: "Paperback",
  },
  {
    img: mobileImg,
    title: "Kindle",
  },
  {
    img: audioBookImg,
    title: "Audiobook",
  },
];

export const CLIENT_LIST = [
  {
    userImg: user1,
    rating: "RateIcon",
    description:
      "This book didn’t just inspire me – it changed how I see myself.",
    name: "Rajeev M.",
  },
  {
    userImg: user2,
    rating: "RateIcon",
    description:
      "It’s like having a mind coach whispering powerful truths in your ears",
    name: "Khushi S.",
  },
  {
    userImg: user3,
    rating: "RateIcon",
    description: "I’ve read dozens of self-help books. This one stands out.",
    name: "Aman R.",
  },
];

export const BUILDING_LIST = [
  {
    icon: "RealStateIcon",
    name: "Real Estate",
  },
  {
    icon: "HospitalIcon",
    name: "Hospitality",
  },
  {
    icon: "LifeStyleIcon",
    name: "Lifestyle",
  },
  {
    icon: "ConstructionIcon",
    name: "Construction",
  },
];

export const PROJECTS_LIST = [
  {
    img: goaImg,
    title: "DVM–Goa ",
    subTitle: "(Dream. Vacation. Mindfulness)",
    description:
      "A signature project that blends nature, luxury, and soulfulness. Located in the serene landscapes of Goa, DVM is a unique combination of:",
    listOne: "Farmhouses surrounded by greenery",
    listTwo: "Stylish apartments with modern amenities",
    listThree: "Peaceful living spaces curated for conscious living",
    descriptionTwo:
      "This project reflects Deepak Sharma’s personal philosophy of living with purpose, in harmony with nature and prosperity.",
  },
  {
    img: sanjeevniHotelImg,
    title: "Sanjeevni Apartment ",
    subTitle: "(Salasar)",
    description:
      "A prestigious hospitality project in the holy town of Salasar, Rajasthan.",
    listOne: "Elegant Hotel for pilgrims and tourists",
    listTwo: "Grand Banquet Hall for weddings and events",
    listThree: "Fine Restaurant offering delightful cuisine",
    descriptionTwo:
      "Sanjeevni Hotel is now a trusted name in hospitality, driven by service and comfort.",
  },
];

export const BUSINESS_LIST = [
  {
    icon: "IntegrityIcon",
    name: "Integrity",
  },
  {
    icon: "InnovationIcon ",
    name: "Innovation",
  },
  {
    icon: "SpiritualityIcon",
    name: "Spirituality",
  },
  {
    icon: "ImpactIcon",
    name: "Impact",
  },
];

export const COLLABORATE_LIST = [
  {
    icon: "ExploreTechIcon",
    name: "Explore the Technology",
  },
  {
    icon: "MovementIcon",
    name: "Join the Movement",
  },
  {
    icon: "ContactDeepakIcon",
    name: "Contact Us",
  },
];

export const MAGNETIC_LIST = [
  "Magnetic Structuring",
  " Cell Vitality",
  "Healing & Clarity",
];

export const RE_WATER_LIST = [
  {
    icon: "InstallAppIcon",
    name: "Install App",
  },
  {
    icon: "SelectGoalIcon",
    name: "Select Goal",
  },
  {
    icon: "AiGenerateIcon",
    name: "AI generates code",
  },
  {
    icon: "WaterFlowIcon",
    name: "Water gets infused",
  },
  {
    icon: "DrinkIcon",
    name: "Drink for 90 days",
  },
];

export const AUDIENCE_LIST = [
  {
    icon: "SpeaksIcon",
    name: "Speaks from Experience",
  },
  {
    icon: "HumbleIcon",
    name: "Humble & Relatable",
  },
  {
    icon: "RealIcon",
    name: "Real, Not Just Theoretical",
  },
];

export const SOCIAL_LINKS_LIST = [
  {
    icon: "ContactCallIcon",
    link: "",
    title: "9253192531",
  },
  {
    icon: "InstagramIcon",
    link: "",
    title: "@deepaksharma.speaks",
  },
  {
    icon: "EmailIcon",
    link: "",
    title: "inspire@makewayindia.com",
  },
  {
    icon: "LocationIcon",
    link: "",
    title: "3579 State Highway 63, Wairau Valley 7271, New Zealand",
  },
];

export const JOURNEY_LIST = [
  "He didn’t speak English.",
  "He didn’t have a rich family.",
  "He didn’t know the “right people.”",
  "But he had one thing most people ignore: Unshakable Belief in Himself.",
];

export const SPEAKER_LIST = [
  {
    icon: "CorporateIcon",
    name: "Corporate",
  },
  {
    icon: "YouthIcon",
    name: "Youth",
  },
  {
    icon: "SeminersIcon",
    name: "Seminars",
  },
];

export const AWARDS_LIST = [
  {
    title: "National Leadership Excellence Award",
    location: "Delhi",
    organizer: "Indian Business Council",
    description:
      "Honored for contributing to Digital India and career guidance for thousands of youth.",
  },
  {
    title: "Youth Icon of the Year",
    location: "Jaipur",
    organizer: "Rajasthan Youth Forum",
    description:
      "Recognized for igniting passion, purpose, and enthusiasm among youth.",
  },
  {
    title: "Visionary Entrepreneur Award",
    location: "Mumbai",
    organizer: "Startup India Summit",
    description:
      "Awarded for building a powerful startup model through Makeway India",
  },
  {
    title: "Social Impact Award",
    location: "Pune",
    organizer: "Bharat NGO Alliance",
    description:
      "Acknowledged for expanding education and tech training in rural areas.",
  },
  {
    title: "Guest of Honour – Inspiration Talk Series",
    location: "Various Universities",
    organizer: "Various Universities",
    description: "Invited as a motivational speaker to inspire and guide.",
  },
];

export const SPOTLIGHT_LIST = [
  {
    img: spotlightImgOne,
    link: "",
    title: "Rise from Ground – Interview by Josh Talks",
    description: "The journey from humble beginnings to extraordinary success.",
    btn: "Platform: Josh Talks YouTube",
  },
  {
    img: spotlightImgTwo,
    link: "",
    title: "Youthpreneur – A Visionary Talk",
    description:
      "Youth entrepreneurship, Aatmanirbhar Bharat, and digital skills.",
    btn: "Platform: YourStory Hindi",
  },
  {
    img: spotlightImgThree,
    link: "",
    title: "Breaking Barriers – The Real Story of Deepak Ji",
    description:
      "A story of struggles, failures, and rising again like a phoenix.",
    btn: "Platform: The Success Show",
  },
  {
    img: spotlightImgFour,
    link: "",
    title: "Radio Zindagi – Voice of the Nation",
    description: "Awareness, education, and inspiration for youth empowerment.",
    btn: "Platform: FM Radio Interview (Delhi)",
  },
  {
    img: spotlightImgFive,
    link: "",
    title: "The Dream of Digital India – Live Discussion",
    description: "The journey from humble beginnings to extraordinary success.",
  },
];

export const WATCH_LIST = [
  {
    img: youtubeImg,
    title: "YouTube Videos",
  },
  {
    img: poadcastImg,
    title: "Audio Podcast",
  },
];

export const PUBLISH_ARTICLES_LIST = [
  {
    img: selfRelienceImg,
    title: "The Real Key to Self-Reliance",
    paperName: "Amar Ujala",
    description:
      "A simple explanation of the importance of self-reliance and skills.",
  },
  {
    img: achieveSuccessImg,
    title: "Achieve Success Through Mind Power",
    paperName: "Punjab Kesari",
    description:
      "Insights on transformation through mind power, meditation, and focus.",
  },
  {
    img: educationRoleImg,
    title: "The Role of Education in the Digital Age",
    paperName: "Hindustan Times Hindi",
    description:
      "Emphasizes the need for modern education systems and digital learning.",
  },
  {
    img: ordinaryImg,
    title: "Ordinary to Extraordinary”- Profile Story",
    paperName: "Navbharat Times",
    description:
      "An inspiring story of Deepak Ji’s life journey and the founding of Makeway India.",
  },
];

export const NEWS_PAPER_LIST = [newsPaperOne, newsPaperTwo, newsPaperThree];
export const SOCIAL_WORK_LIST = [
  {
    icon: freeCoachingImg,
    title: "Free Coaching for Underprivileged Students",
    location: "Hisar, Fatehabad, and surrounding rural areas.",
    description:
      "Provided free technical education and career guidance to economically disadvantaged children.",
  },
  {
    icon: oneTreeImg,
    title: "One Tree – One Life Campaign",
    description:
      "Led the planting of 5,000+ trees and spread awareness about environmental conservation.",
  },
  {
    icon: womenEmpowerImg,
    title: "Women Empowerment Workshops",
    description:
      "Organized training, motivation, and digital learning sessions to make women self-reliant in villages and cities.",
  },
  {
    icon: bloodImg,
    title: "Blood Donation and Health Camps",
    description:
      "Along with the Makeway India team, organized multiple blood donation drives, free health check-ups, and medication distribution camp.",
  },
  {
    icon: visonImg,
    title: "Vision for Youth Mission",
    description:
      "Inspired thousands of youth towards de-addiction, career planning, and life vision development.",
  },
];

export const OUR_PRODUCT_LIST = [
  {
    img: magnaticImg,
    title: "Magnetic Devices:",
    description:
      "Makeway India's cutting-edge magnetic devices are designed to enhance the body's natural energy flow, improve circulation, and promote overall wellness. Whether it's for physical or mental rejuvenation, our products aim to help you live a healthier life.",
  },
  {
    img: waterRescorseImg,
    title: "Re-code Water Devices:",
    description:
      "Our Re-code Water Device harnesses advanced technology to enhance the quality of water. By structuring water at a molecular level, we ensure that it’s more effective for hydration and improves the body's ability to absorb nutrients. This device represents a major step toward healthier, more sustainable living.",
  },
];

export const GLOBAL_LIST = [
  {
    icon: accessImg,
    title: "Access to Advanced Wellness Solutions:",
    description:
      "Customers will now have access to cutting-edge wellness technology that focuses on health, hydration, and energy optimization.",
  },
  {
    icon: worldImg,
    title: "Worldwide Availability:",
    description:
      "Thanks to our partnership, Makeway’s products will be available to customers across the globe, bringing modern solutions to the world’s growing demand for healthy living technologies.",
  },
  {
    icon: sustainImg,
    title: "Sustainable and Effective Solutions:",
    description:
      "Both the Magnetic Devices and Re-code Water Devices are designed with sustainability in mind, ensuring that they contribute to a greener planet while improving your personal health.",
  },
];

export const STEPS_LIST = [
  {
    step: "01",
    title: "Innovative Technology",
    description:
      "Our products combine the latest advancements in wellness technology, offering you real-world solutions that fit into your daily life.",
  },
  {
    step: "02",
    title: "Global Impact",
    description:
      "With Jeena Sikho's global marketing network, our products are set to reach people across the world, promoting healthier living standards for everyone.",
  },
  {
    step: "03",
    title: "Commitment to Quality",
    description:
      "Both Makeway and Jeena Sikho share a commitment to providing only the highest quality products that positively impact the lives of users.",
  },
];

export const PRIVACY_POLICY_LIST = [
  {
    heading: "Introduction",
    type: "normal",
    points: [
      "At Makeway India, your privacy is important to us. This Privacy Policy describes how we collect, use, and safeguard your personal information when you access our website, engage with our wellness products, or use our services.",
    ],
  },
  {
    heading: "Information We Collect",
    type: "numbered",
    points: [
      "Personal Information: This includes your name, email address, phone number, shipping address, and other details you provide when contacting us or placing an order.",
      "Usage Data: We collect certain technical information automatically, such as your IP address, browser type, device type, pages visited, and the date/time of your visit.",
      "Cookies & Tracking Tools: We use cookies and similar technologies to enhance your browsing experience and to understand how our website performs.",
    ],
  },
  {
    heading: "How We Use Your Information",
    description: "We use your personal data for the following purposes:",
    type: "numbered",
    points: [
      "To Process Orders and Deliver Products: We use your details to fulfill purchases, manage logistics, and provide support.",
      "To Communicate with You: This includes responding to queries, order updates, and — only with your consent — sending promotional emails about new wellness products or offers.",
      "To Enhance Our Services: Your activity on the site helps us analyze trends and enhance the experience for all users.",
    ],
  },
  {
    heading: "Data Sharing Practices",
    description:
      "We do not sell or rent your personal data. Your information may only be shared with:",
    type: "numbered",
    points: [
      "Trusted Service Partners: Who assist in payment processing, order fulfillment, customer support, and website management.",
      "Legal Authorities: Only if required to comply with applicable laws or regulations.",
    ],
  },
  {
    heading: "Data Security",
    type: "normal",
    points: [
      "We maintain strict technical and organizational safeguards to protect your personal information from unauthorized access, misuse, or disclosure.",
    ],
  },
  {
    heading: "Your Rights",
    type: "mixed",
    points: [
      "You have full control over your data:",
      "Request access or corrections to your personal information.",
      "Ask us to delete your data from our records.",
      "Withdraw consent for marketing communications at any time.",
    ],
  },
  {
    heading: "Contact Us",
    type: "normal",
    points: [
      "If you have questions or concerns about this policy or your data, please reach out to us at:",
      "support@makewayindia.com",
    ],
  },
  {
    heading: "Changes to this Privacy Policy",
    type: "normal",
    points: [
      "At Makeway India, we continuously strive to improve our services and protect your privacy. As a result, this Privacy Policy may be updated periodically to reflect changes in our practices or legal requirements.",
      "Whenever we make significant changes, we’ll inform you through our website or by other appropriate means of communication.",
      "Last Updated On: April 23, 2025",
    ],
  },
];

export const TERMS_POLICY_LIST = [
  {
    heading: "Agreement to Terms",
    description:
      "By using this website, you acknowledge and agree to be bound by these Terms & Conditions and our Privacy Policy. If you do not agree, please discontinue use of the site and services.",
  },
  {
    heading: "Intellectual Property Rights",
    description:
      "All website content—including product designs, images, branding, written material, and code—is the intellectual property of Makeway India. Reproduction or redistribution without written consent is not permitted.",
  },
  {
    heading: "User Contributions",
    description:
      "If you submit content (e.g., testimonials, reviews, inquiries), you are responsible for ensuring it is accurate, respectful, and free from harmful, illegal, or misleading information. We reserve the right to remove any such content at our discretion.",
  },
  {
    heading: "Limitation of Liability",
    description:
      "Makeway India is not liable for any indirect, incidental, or consequential damages resulting from the use or inability to use our site, services, or products, even if advised of such possibilities.",
  },
  {
    heading: "Account Suspension or Termination",
    description:
      "We reserve the right to suspend or permanently block access to users who violate these terms, engage in misuse, or act in ways that compromise the safety or reputation of Makeway India.",
  },
  {
    heading: "Updates to Terms",
    description:
      "These Terms & Conditions may be revised periodically to reflect operational, legal, or regulatory updates. Continued use of the site following changes will constitute your acceptance of the updated terms.",
  },
  {
    heading: "Contact Us",
    description:
      "For any questions or concerns regarding these terms, please contact us at:",
  },
];
